<template>
  <div class="container px-0">
    <div class="row sticky-header pt-5 mt-n5 mr-0 ml-0 pb-5">
      <div class="col-12 col-sm-8 col-lg-7 col-xl-7">
        <div class="row m-0 pl-0">
          <div class="shop-info">
            <h2 class="flex-v-center typo-heading24 typo-semibold shop-name">{{ $t("integration.title") }}</h2>
            <p class="typo-paragrap14 typo-regular text-light-low mt-1">{{ $t("integration.subtitle") }}</p>
          </div>
        </div>
      </div>

      <div class="pr-0 col-12 col-sm-4 col-lg-5 col-xl-5 d-flex flex-column-reverse">
        <div class="row mr-0">
          <div class="col-12 ml-auto">
            <div class="row">
              <GpInputSearch ref="GpInputSearch" :clear="true" v-model="query" :placeholder="$t('integration.placeholder')" />
            </div>
            <div class="tags-holder">
              <Tag :removable="true" v-for="(tag, i) in tags" :key="'__' + i" :item="tag" @remove="removeTag" @select="removeTag" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row relative">
      <!-- <div class="mt-2 col-12" v-if="topic.loading">
      </div> -->
      <!-- <GLoading class="mx-2" v-if="topic.loading"/> -->
      <template v-if="apps.fetched">
        <template v-if="apps.list.length">
          <template v-if="filteredList.length">
            <AppItem :item="app" v-for="(app, ind) in filteredList" :key="'_app_' + ind" @select="viewDetails" @tag="addTag" />
            <AppItem key="_soon_" :comingSoon="true" v-if="!tags.length && query == ''" />
          </template>
          <template v-else>
            <GpEmptyPage page="search" :customContent="true">
              <template #content>
                <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">{{ $t("empty.search.title") + " " + query }}</p>
                <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("empty.integrations.searchEmpty") }}</p>
              </template>
            </GpEmptyPage>
          </template>
        </template>
        <template v-else>
          <GpEmptyPage page="videoTutorial" />
        </template>
      </template>
      <template v-else>
        <AppItem v-for="ind in 6" :key="'_loading_' + ind" />
        <AppItem v-for="ind in 3" :key="'_soon_' + ind" :comingSoon="true" />
      </template>
    </div>

    <Modal :hideExit="false" cClass="app-details-modal" padding="p-0" closeClass="app-details-close p-1" @cancel="closeDetails" v-if="appDetail" @container="closeDetails">
      <div class="app-details py-4 px-3 text-black bg-light3">
        <!-- <div class="app-details-close" @click="closeDetails">
          <i class="icon icon-cancel"></i>
        </div> -->
        <!-- Logo and some info -->
        <div class="row">
          <div class="col-8">
            <div class="row">
              <div class="col-12 d-flex">
                <div class="app-logo">
                  <img :src="appDetail.metadata.appIcon" v-if="appDetail && appDetail.metadata && appDetail.metadata.appIcon" />
                  <img class="app-logo-mock" v-else :src="publicPath + require('@/core/assets/Integration/calendar.svg')" />
                </div>
                <div class="app-info ml-2">
                  <h4 class="typo-heading20 typo-medium mb-half">
                    {{ appDetail.label }}
                  </h4>
                  <p class="typo-button14 typo-medium d-flex align-items-center mb-1">
                    <svg width="20" height="20" viewBox="0 0 20 22" fill="none" class="text-warning">
                      <g>
                        <path d="M19.6291 8.05486C19.5401 7.80434 19.3802 7.58823 19.1709 7.43537C18.9615 7.28252 18.7126 7.2002 18.4574 7.19941H13.3849C13.2986 7.19947 13.2144 7.17146 13.1439 7.11923C13.0735 7.067 13.0202 6.99314 12.9916 6.90786L11.1708 1.50192C11.0816 1.25206 10.9217 1.03669 10.7124 0.884647C10.5032 0.732599 10.2546 0.651123 9.99992 0.651123C9.74526 0.651123 9.49668 0.732599 9.28743 0.884647C9.07819 1.03669 8.91828 1.25206 8.82909 1.50192L8.82492 1.51589L7.00826 6.90786C6.97965 6.993 6.92654 7.06676 6.85624 7.11898C6.78595 7.17119 6.70193 7.19929 6.61576 7.19941H1.54159C1.28477 7.19921 1.03413 7.28187 0.823742 7.43616C0.61336 7.59045 0.453451 7.80887 0.365766 8.06172C0.27808 8.31457 0.266873 8.58957 0.33367 8.84933C0.400466 9.10909 0.542024 9.34099 0.739089 9.51349L5.05909 13.267C5.12371 13.3232 5.17062 13.3985 5.19367 13.4831C5.21672 13.5677 5.21483 13.6576 5.18826 13.741L3.37326 19.442C3.28938 19.7056 3.28772 19.9903 3.36853 20.2549C3.44933 20.5196 3.60841 20.7504 3.82275 20.9141C4.03709 21.0778 4.29559 21.1658 4.56084 21.1654C4.82609 21.165 5.08435 21.0763 5.29826 20.912L9.75326 17.4902C9.82469 17.4353 9.91095 17.4058 9.99951 17.4058C10.0881 17.4058 10.1743 17.4353 10.2458 17.4902L14.6991 20.9111C14.9129 21.0759 15.1713 21.1652 15.4368 21.1659C15.7023 21.1667 15.9611 21.0788 16.1757 20.9152C16.3904 20.7515 16.5497 20.5205 16.6306 20.2556C16.7115 19.9908 16.7098 19.7058 16.6258 19.442L14.8108 13.7375C14.7842 13.6541 14.7823 13.5642 14.8053 13.4796C14.8284 13.395 14.8753 13.3197 14.9399 13.2635L19.2683 9.50477C19.4628 9.3308 19.6017 9.0985 19.6662 8.83922C19.7308 8.57995 19.7178 8.30618 19.6291 8.05486Z" fill="currentColor" />
                      </g>
                    </svg>

                    <span class="d-inline-flex align-items-center ml-1">
                      {{ appDetail.metadata.ratingPoints || 0 }}
                    </span>
                  </p>
                  <p class="typo-paragraph12 typo-lh-150 text-light-disabled mb-1">
                    <span>{{ $t("integration.by", { name: appDetail.author || "GemPages" }) }}</span>
                    <span> | </span>
                    <a :href="appDetail.website || 'https://gempages.net'" target="_blank" class="text-primary">
                      {{ website }}
                    </a>
                  </p>
                  <div class="row pt-half">
                    <div class="col-12">
                      <a class="support-link d-flex align-items-center typo-paragraph12 typo-lh-150 text-light-disabled" target="_blank" :href="'mailto:' + (appDetail.metadata.emailSupport || 'contact@gempages.help')">
                        <svg width="14" height="15" viewBox="0 0 14 15" class="mr-1">
                          <path d="M11.6668 2.25488H2.3335C1.36706 2.25488 0.583496 3.03845 0.583496 4.00488V11.0049C0.583496 11.9713 1.36706 12.7549 2.3335 12.7549H11.6668C12.6333 12.7549 13.4168 11.9713 13.4168 11.0049V4.00488C13.4168 3.03845 12.6333 2.25488 11.6668 2.25488ZM11.6668 3.42155C11.7338 3.42155 11.7971 3.43511 11.8568 3.45582L7.00016 7.34111L2.14348 3.45582C2.20341 3.43511 2.26656 3.42155 2.3335 3.42155H11.6668ZM11.6668 11.5882H2.3335C2.0112 11.5882 1.75016 11.3272 1.75016 11.0049V4.63532L6.63573 8.54365C6.74218 8.62897 6.87125 8.67155 7.00016 8.67155C7.12908 8.67155 7.25814 8.62897 7.3646 8.54365L12.2502 4.63532V11.0049C12.2502 11.3272 11.9891 11.5882 11.6668 11.5882Z" fill="currentColor" />
                        </svg>
                        {{ appDetail.metadata.emailSupport || "contact@gempages.help" }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 align-items-end justify-content-end d-flex">
            <!-- <div class="col-7 p-0"> -->
            <a class="btn btn-try btn-primary" target="_blank" :href="appDetail && appDetail.metadata && appDetail.metadata.installLink">{{ $t("integration.tryIt") }}</a>
            <!-- </div> -->
          </div>
        </div>
        <!-- Description and tags -->
        <div class="row mt-4">
          <div class="col-7">
            <p class="typo-paragraph14 typo-regular-150 text-light-low" v-html="appDetail.short_desc"></p>
          </div>
          <div class="col-5">
            <!-- <div class="row"> -->
            <!-- <div class="col-10 ml-auto"> -->
            <div class="bundles mt-n1 ml-n1">
              <Tag class="mt-1 ml-1" v-for="(w, _i) in appDetail.bundle" :key="'selected' + _i" :item="w" />
            </div>
            <!-- </div> -->
            <!-- </div> -->
          </div>
        </div>

        <hr class="bg-dark-high my-3" />
        <p class="typo-heading16 typo-medium mb-2">{{ $t("integration.howToInstall") }}</p>
        <p class="typo-paragraph14 typo-regular typo-lh-150 text-light-low mb-2" v-html="appDetail.metadata.howToInstall"></p>
        <div class="app-video">
          <template v-if="appDetail && appDetail.metadata && appDetail.metadata.helpVideo">
            <video controls ref="video" class="" width="100%" height="auto" loop="true" preload="none" muted="false" playsinline autoplay="true" :src="appDetail.metadata.helpVideo">
              <source :src="appDetail.metadata.helpVideo" type="video/mp4" />
            </video>
          </template>
          <img v-else :src="publicPath + require('@/core/assets/Integration/video.jpg')" />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { GpInputSearch } from "@/core/shared/GpForms";
import { AppItem } from "../components";
import { mapState, mapActions } from "vuex";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
import Tag from "../components/Tag";
export default {
  name: "IntegrationDefault",
  components: {
    AppItem,
    GpEmptyPage,
    GpInputSearch,
    Tag
  },
  data() {
    return {
      appDetail: null,
      query: "",
      inRoute: false,
      tags: []
    };
  },
  computed: {
    ...mapState("integration", {
      apps: state => state.apps,
      appID: state => state.appID
    }),
    website() {
      if (!this.appDetail.website) {
        return "https://gempages.net";
      }
      let split = this.appDetail.website.split("?");
      if (!split || !split.length) return "https://gempages.net";

      let website = split[0];
      return website;
    },
    appsList() {
      if (!this.apps || !this.apps.list || !this.apps.list.length) {
        return [];
      }
      if (!this.tags || !this.tags.length) return this.apps.list;
      const byTags = this.tags.map(item => {
        return item.name;
      });
      return this.apps.list.filter(item => {
        if (!item || !item.data_attr) return {};

        // Loop check if any of selected tags contains in bundle
        for (let i = 0, len = byTags.length; i < len; i++) {
          const tag = byTags[i];
          if (item.features && item.features.length && tag) {
            if (
              item.features
                .join("<-☼->")
                .toLowerCase()
                .indexOf(tag.toLowerCase()) > -1
            ) {
              return true;
            }
          }
        }

        return false;
      });
    },
    filteredList() {
      let q = this.query;
      return this.appsList
        .filter(item => {
          if (item.status == "hide") {
            return false;
          }
          return (item.label || "").toLowerCase().indexOf(q.toLowerCase()) > -1;
        })
        .sort((a, b) => {
          if (a.label == "EcomSolid") return -1;
          if (b.label == "EcomSolid") return 1;
          const orderA = a?.order || 99;
          const orderB = b?.order || 99;
          if (orderA != orderB) {
            return orderA - orderB;
          }
          if (a.created_at != b.created_at) {
            return new Date(b.created_at || 0) - new Date(a.created_at || 0);
          }
          return 0;
        });
    }
  },
  created() {
    this.checkFetchData();
  },
  mounted() {
    this.inRoute = true;
    this.handleScroll();
  },
  beforeDestroy() {
    this.inRoute = false;
  },
  methods: {
    ...mapActions("integration", {
      fetchData: "fetchAppsIntegration"
    }),
    handleScroll() {
      const body = document.getElementById("mainBody");
      if (body) {
        body.onscroll = () => {
          const scrollY = body.scrollTop;
          const stickyHeader = document.querySelector(".sticky-header");
          if (scrollY > 1) {
            stickyHeader.style.borderBottom = "solid 1px rgba(73, 73, 73, 0.1)";
          } else {
            stickyHeader.style.borderBottom = "none";
          }
        };
      }
    },
    onTabChangeHandler() {},
    checkFetchData() {
      if (!this.apps.fetched && !this.apps.loading) {
        this.fetchData();
      }
    },
    viewDetails(app) {
      this.appDetail = app;
    },
    closeDetails() {
      this.appDetail = null;
    },
    onSearch() {},
    addTag(tag) {
      if (this.tags.length >= 4) {
        this.gSnackbarCommit({
          message: "Only 4 Tags Selected Once",
          type: "error"
        });
        return;
      }
      let found = this.tags.find(item => {
        return item.name === tag.name;
      });
      if (!found) this.tags.push(tag);
    },
    removeTag(tag) {
      let index = this.tags.findIndex(item => {
        return item.name === tag.name;
      });
      if (index > -1) this.tags.splice(index, 1);
    }
  }
};
</script>

<style lang="scss">
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 11;
  background: $bg;
}
.bb1sg {
  border-bottom: 1.03px solid $textDarkModeHigh;
}
.relative {
  min-height: 400px;
}

.app {
  &-details {
    background: $light3;
    border-radius: $radius;
    width: 70vw;
    max-width: 880px;
    min-width: 650px;
    // max-height: 80vh;
    min-height: 500px;
    // overflow: hidden;
    position: relative;

    // &:hover {
    //   overflow: overlay;
    // }
  }

  &-logo {
    @include flex-center;
    $size: 100px;
    width: $size;
    height: $size;
    // border-radius: 5px;
    background: $grey4;
    overflow: hidden;

    img {
      width: 100%;
    }

    &-mock {
      width: $size - 30px;
      height: $size - 30px;
    }
  }

  &-info {
    flex: 1;
  }

  &-video {
    border: 1px solid #f2f3f4;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    img {
      width: 100%;
    }

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-thumb {
      background: $grey2;
      border-radius: 0px;
      transition: background 0.2s ease;
      &:hover {
        background: $shade5;
      }
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }
  }
}

.btn-try {
  min-width: 152px;
}

.bundles {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-end;
}

.tags-holder {
  display: flex;
  flex-wrap: wrap;
  margin: -4px;
  margin-top: 6px;
  justify-content: flex-end;
  ::v-deep {
    .tag {
      margin: 2px;
    }
  }
}
</style>
